import { render, staticRenderFns } from "./BatchesTable.vue?vue&type=template&id=098f852e&scoped=true&"
import script from "./BatchesTable.vue?vue&type=script&lang=js&"
export * from "./BatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchesTable.vue?vue&type=style&index=0&id=098f852e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f852e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
